<template>
  <BLayoutView
    :back-route="backRoute"
    :edit-route="editRoute"
    :title="pageTitle"
    :loading="isLoading"
    :skeleton="isLoadingAsyncData"

    :saveable="saveable"
    :editable="editable"
    :deletable="deletable"

    @delete="onDelete(single)"
    @save-menu="onCheck"
  >
    <template #form>
      <ComponentForm
        ref="form"
        v-bind="viewTypeOptions"
        :data="viewTypeOptions.isCreate ? void 0 : single"
        :skeleton="isLoadingAsyncData"
        @save="onCheck()"
      />
    </template>

    <template #footer.right>
      <v-btn
        v-if="!isLoadingAsyncData"
        outlined
        class="mr-2"
        @click="$refs.form.addSheet()"
        v-text="'Добавить лист'"
      />
      <v-btn
        v-if="!isLoadingAsyncData"
        :disabled="!hasEditableSheets || isOpenedModal"
        outlined
        @click="openModal"
        v-text="'Заполнить'"
      />
    </template>
  </BLayoutView>
</template>

<script>
import { createModalConfirm } from '@/helpers/createModalConfirm'
import { createViewMixin } from '@/helpers/mixins/createViewMixin'
import { createDeletableMixin } from '@/helpers/mixins/createDeletableMixin'
import { createLKPublicationsFormdataModal } from '@/views/LKPublications/formdata/utils'
import { FormTemplatesModel as Model } from './Model'
import { FormTemplatesStoreMapper as StoreMapper, FormTemplatesStoreModule as StoreModule } from './store'
import { FORM_TEMPLATE_ROUTES as ROUTES } from './utils'

import BLayoutView from '@/components/layouts/BLayoutView.vue'
import ComponentForm from './components/FormTemplatesForm.vue'


const mixinOptions = { Model, StoreModule, ROUTES }
const viewMixin = createViewMixin(mixinOptions)
const deletableMixin = createDeletableMixin(mixinOptions)

/** @typedef { import('@/helpers/mixins/createViewMixin').ViewMixin<any, StoreModule> } View */
/** @typedef { import('@/helpers/mixins/createDeletableMixin').DeletableMixin<any, StoreModule> } Deletable */

export default {
  name: 'ViewFormTemplatesView',
  $_veeValidate: {
    /** @type 'new' */
    validator: 'new',
  },
  components: {
    BLayoutView,
    ComponentForm,
  },
  mixins: [
    viewMixin,
    deletableMixin,
  ],
  data: () => ({
    isOpenedModal: false,
    backRoute: { name: ROUTES.LIST },
  }),
  computed: {
    createRoute() {
      return {
        name: ROUTES.CREATE,
      }
    },
    editRoute() {
      return {
        name: ROUTES.EDIT,
        props: { id: this.id },
      }
    },
    hasEditableSheets() {
      return Boolean(
        this.$refs.form?.form?.sheets?.reduce(
          (isEditable, sheet) => isEditable || Boolean(sheet?.cells?.length),
          false,
        ),
      )
    },
  },
  /** @type { View & Deletable } */
  methods: {
    ...StoreMapper.mapActions(['count']),
    async onCheck(type) {
      const form = await this.$refs.form.onBeforeSubmit()
      if (!form) {
        this.$notice.validatorFormError(this)
        return
      }

      this.isLoading = true
      const count = await this.count(form)
      this.isLoading = false
      if (count > 0) {
        const propsData = {
          titleText: 'Сохранение Шаблона Веб-Формы',
          mainText: 'Некоторые пользователи уже заполнили информацию по этому шаблону ФСД. Редактирование шаблона может привести к ошибкам при сдаче отчета у пользователей. Вы уверены, что хотите изменить шаблон?',
          cancelBtn: 'Нет',
          successBtn: 'Да',
          action: () => this.onSave(form, type),
        }

        const modal = await createModalConfirm(this, propsData)
        await modal.open().finally(() => modal.close())
      } else {
        await this.onSave(form, type)
      }
    },
    async onSave(form, type) {
      const result = await this.onSubmit(form)
      this.$refs.form.onReset()

      const { id } = result
      const editRoute = { name: ROUTES.EDIT, params: { id } }
      this.toSave(this.backRoute, this.createRoute, editRoute, type)
    },
    async onDelete(data) {
      const result = await this.toDelete(data)
      if (!result) return
      this.$router.replace(this.backRoute)
    },
    async openModal() {
      if (!this.hasEditableSheets) return
      this.isOpenedModal = true
      const form = JSON.parse(JSON.stringify(this.$refs.form.form))
      form.use_excel = true // В админке Excel показываем всегда.
      // eslint-disable-next-line object-curly-newline
      const options = { formTemplate: form, resetOnClose: true, excel: true, canEdit: true }
      const modal = await createLKPublicationsFormdataModal(this, options)
      await modal.open()
      this.isOpenedModal = false
    },
  },
}
</script>
